import React, { useEffect } from "react";
import "./how-it-works.css";

const steps = [
  { icon: "📝", title: "Submit Your Loan Request", desc: "Quickly fill out a secure online form to request your desired loan amount." },
  { icon: "✅", title: "Approval Within Hours", desc: "Our AI-powered system reviews your application for instant approval." },
  { icon: "💵", title: "Funds Transferred", desc: "Receive your funds directly into your bank account without delays." },
  { icon: "📈", title: "Track & Manage", desc: "Easily manage your loan, repayment schedule, and get personalized advice." },
];

const HowItWorks = () => {

  useEffect(() => {
    const steps = document.querySelectorAll('.hiw-step');

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if(entry.isIntersecting){
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.3 });

    steps.forEach(step => observer.observe(step));
  }, []);

  return (
<section className="hiw-section">
  {/* Cutted SVG Background */}
  <svg className="hiw-background-svg" viewBox="0 0 1440 600" preserveAspectRatio="none">
    <polygon points="0,0 1440,0 1440,400 0,500" fill="#e0f2fe" />
    <polygon points="0,0 1440,0 1440,300 0,400" fill="#fefefe" opacity="0.6"/>
    <polygon points="0,100 1440,0 1440,200 0,300" fill="#dbeafe" opacity="0.4"/>
  </svg>

  <h2 className="hiw-title">How It Works</h2>

  <div className="hiw-timeline">
    {steps.map((step, i) => (
      <div key={i} className={`hiw-step hiw-step-${i % 2 === 0 ? "left" : "right"}`}>
        <div className="hiw-step-circle">{step.icon}</div>
        <div className="hiw-step-content">
          <h3>{step.title}</h3>
          <p>{step.desc}</p>
        </div>
      </div>
    ))}
  </div>
</section>

  );
};

export default HowItWorks;
